if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        const idInput = this.form ? this.form.querySelector('[name=id]') : null;
        if (idInput) idInput.disabled = false;
        if (this.form) this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton = this.querySelector('[type="submit"], [name="add"], .product-form__submit');
        this.upsellVariantId = this.dataset.upsellVariantId;
        if (document.querySelector('cart-drawer') && this.submitButton) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        if (evt) { evt.preventDefault(); evt.stopPropagation(); }
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

        let itemsPayload = [];

        // --- Tìm radio offer đang chọn ---
        const selectedRadio = document.querySelector('.quantity-breaks-container input[type="radio"]:checked')
                           || document.querySelector('input[type="radio"][name="quantity"]:checked');

        if (selectedRadio) {
          // Tìm label wrapper tương ứng với radio
          let qbWrapper = selectedRadio.nextElementSibling;
          if (!qbWrapper || !qbWrapper.classList.contains('quantity-break')) {
            qbWrapper = document.querySelector('label[for="' + selectedRadio.id + '"]');
          }

          if (qbWrapper) {
            // CASE 1: Bundle với nhiều dropdown variant (Item 1: Black, Item 2: Brown...)
            const bundleDropdowns = qbWrapper.querySelectorAll('.quantity-break__variant-select');
            if (bundleDropdowns.length > 0) {
              const variantMap = {};
              bundleDropdowns.forEach(select => {
                const vId = Number(select.value);
                if (vId) variantMap[vId] = (variantMap[vId] || 0) + 1;
              });
              for (const [vId, qty] of Object.entries(variantMap)) {
                itemsPayload.push({ id: Number(vId), quantity: qty });
              }
            } else {
              // CASE 2: Single product - variant đã được chọn bởi variant_picker
              // Radio value = số lượng muốn mua
              const qty = Math.max(1, Number(selectedRadio.value) || 1);
              // Lấy variant ID từ form (đã được set bởi variant_picker)
              const mainVariantId = this.form.querySelector('input[name="id"]')?.value
                                 || document.querySelector('input[name="id"]')?.value;
              if (mainVariantId && Number(mainVariantId) > 0) {
                itemsPayload.push({ id: Number(mainVariantId), quantity: qty });
              }
            }
          }
        }

        // --- Fallback: không có radio, dùng form trực tiếp ---
        if (itemsPayload.length === 0) {
          const mainVariantId = this.form.querySelector('input[name="id"]')?.value
                             || document.querySelector('input[name="id"]')?.value;
          const qtyInput = this.form.querySelector('input[name="quantity"]')
                        || document.querySelector('input[name="quantity"]');
          const qty = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
          if (mainVariantId && Number(mainVariantId) > 0) {
            itemsPayload.push({ id: Number(mainVariantId), quantity: qty });
          }
        }

        if (itemsPayload.length === 0) {
          console.error('[ProductForm] No items to add to cart!');
          if (this.submitButton) { this.submitButton.classList.remove('loading'); this.submitButton.removeAttribute('aria-disabled'); }
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        const sections = this.cart && typeof this.cart.getSectionsToRender === 'function'
          ? this.cart.getSectionsToRender().map((s) => s.id)
          : ['cart-drawer', 'cart-icon-bubble'];

        fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: itemsPayload, sections: sections, sections_url: window.location.pathname })
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status && response.status !== 200) {
            if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            this.handleErrorMessage(response.description || response.message);
            const soldOutMessage = this.submitButton?.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }
          this.error = false;

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            if (response.sections && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(response);
            }
            if (typeof cartDrawer.open === 'function') {
              setTimeout(() => cartDrawer.open(), 50);
            } else {
              cartDrawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            }
          }

          fetch((window.routes?.cart_url || '/cart') + '.js')
            .then(r => r.json())
            .then(cart => {
              if (window.CartProgressManager?.updateCartUI) window.CartProgressManager.updateCartUI(cart);
            }).catch(console.error);
        })
        .catch((e) => { console.error('Add to cart AJAX error:', e); })
        .finally(() => {
          if (this.submitButton) {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          }
          if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (spinner) spinner.classList.add('hidden');
        });
      }

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);
        return {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: upsellFormData,
        };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}